import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  validationSchema,
  initialValues,
} from "../../componentes/IngresarCodigoRecuperacionClave";
import { useFormik } from "formik";
import "../../scss/index.scss";
import imaLogo from "../../imagenes/logo.png";
import { Grid, Header, Image, Segment } from "semantic-ui-react";
import {
  necesitas_ayuda_con_tu_contrasena,
  ingresa_el_codigo_de_recuperacion_que_recibiste_en_tu_casilla_de_correo,
  codigo_de_recuperacion,
} from "../../utils/traductor";
import { apiUsuario } from "../../api/usuario";
import Swal from "sweetalert2";
import { estiloColores } from "../../estilos/colores";
import { ENTORNO, HabilitarGoogleRecaptcha } from "../../utils/constantes";
import { setPermiteCambiarEmail } from "../../utils/variablesLocales";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import CssBaseline from "@mui/material/CssBaseline";
import useScrollTrigger from "@mui/material/useScrollTrigger";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Fab from "@mui/material/Fab";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import Fade from "@mui/material/Fade";
import IconButton from "@mui/material/IconButton";
import CheckIcon from "@mui/icons-material/Check";
import { estiloSegmento } from "../../estilos";
import PropTypes from "prop-types";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { TextField } from "@mui/material";
import { apigoogleRecaptchaV3 } from "../../api";
import ReactRecaptcha3 from "react-google-recaptcha3";

const apigooglerecaptchav3 =
  HabilitarGoogleRecaptcha === true ? new apigoogleRecaptchaV3() : null;

const apiusuario = new apiUsuario();

function ScrollTop(props) {
  const { children, window } = props;
  // Note that you normally won't need to set the window ref as useScrollTrigger
  // will default to window.
  // This is only being set here because the demo is in an iframe.
  const trigger = useScrollTrigger({
    target: window ? window() : undefined,
    disableHysteresis: true,
    threshold: 100,
  });

  const handleClick = (event) => {
    const anchor = (event.target.ownerDocument || document).querySelector(
      "#back-to-top-anchor"
    );

    if (anchor) {
      anchor.scrollIntoView({
        block: "center",
      });
    }
  };

  return (
    <Fade in={trigger}>
      <Box
        onClick={handleClick}
        role="presentation"
        sx={{ position: "fixed", bottom: 16, right: 16 }}
      >
        {children}
      </Box>
    </Fade>
  );
}

ScrollTop.propTypes = {
  children: PropTypes.element.isRequired,
  window: PropTypes.func,
};

const ValidarTokenRecaptcha = async (
  tokenGoogleRecaptchaV3,
  ipPublicaValor,
  codigorecuperacion,
  navigateToCambiarClave
) => {
  const respuestaVerificacionRecaptcha = await apigooglerecaptchav3.verificar(
    tokenGoogleRecaptchaV3,
    ipPublicaValor
  );

  if (respuestaVerificacionRecaptcha === true) {
    IngresarConfirmar(codigorecuperacion, navigateToCambiarClave);
  } else {
  }
};

const IngresarConfirmar = async (
  codigorecuperacion,
  navigateToCambiarClave
) => {
  const response = await apiusuario.validarCodigoRecuperacion(
    codigorecuperacion
  );

  if (response === "Ok") {
    //destruir el recaptcha
    if (HabilitarGoogleRecaptcha) ReactRecaptcha3.destroy();

    setPermiteCambiarEmail("1");
    navigateToCambiarClave();
  } else {
    Swal.fire({
      title: "Error!",
      text: response,
      icon: "error",
      confirmButtonText: "Ok",
      confirmButtonColor: estiloColores.Gris,
    });
  }
};

export function IngresarCodigoRecuperacionClave(props) {
  const navigate = useNavigate();

  const navigateToCambiarClave = () => {
    navigate(ENTORNO.URL_APLICACION + "/CambiarClave");
  };

  const navigateToOlvidoSuClave = () => {
    navigate(ENTORNO.URL_APLICACION + "/OlvidoSuClave");
  };

  const formik = useFormik({
    initialValues: initialValues(),
    validationSchema: validationSchema(),
    validateOnChange: false,
    onSubmit: async (formValue) => {
      try {
        //validacion google recaptcha v3
        //1. calculo ip publica
        const ipPublica = require("react-public-ip");
        const ipPublicaValor = (await ipPublica.v4()) || "";

        //2. obtengo token
        if (HabilitarGoogleRecaptcha) {
          ReactRecaptcha3.getToken().then(
            (tokenGoogleRecaptchaV3) => {
              ValidarTokenRecaptcha(
                tokenGoogleRecaptchaV3,
                ipPublicaValor,
                formik.values.codigorecuperacion,
                navigateToCambiarClave
              );
            },
            (error) => {
              console.log(error);
            }
          );
        } else {
          IngresarConfirmar(
            formik.values.codigorecuperacion,
            navigateToCambiarClave
          );
        }
      } catch (error) {
        console.log(error);
      }
    },
  });

  useEffect(() => {
    if (HabilitarGoogleRecaptcha) {
      ReactRecaptcha3.init(ENTORNO.GOOGLE_RECAPTCHA_V3_SITEKEY).then(
        (status) => {}
      );
    }
  }, []);

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  return (
    <div style={{ overfxlow: "hidden", touchAction: "none" }}>
      <form onSubmit={formik.handleSubmit}>
        <React.Fragment>
          <CssBaseline />
          <AppBar style={{ background: "#DC030E" }}>
            <Toolbar>
              <IconButton
                size="large"
                edge="start"
                color="inherit"
                onClick={navigateToOlvidoSuClave}
                aria-label="menu"
                sx={{ mr: 2 }}
              >
                <ArrowBackIcon fontSize="medium" />
              </IconButton>
              <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                {codigo_de_recuperacion}
              </Typography>
              <IconButton
                size="large"
                aria-label="display more actions"
                edge="end"
                color="inherit"
                type="submit"
              >
                <CheckIcon />
              </IconButton>
            </Toolbar>
          </AppBar>
          <Toolbar id="back-to-top-anchor" />
          <Container>
            <Segment style={estiloSegmento.Pasajero}>
              <Grid textalign="center" container style={{ padding: "5em 0em" }}>
                <Grid.Row>
                  <div className="ingresar">
                    <Grid.Column style={{ maxWidth: 450 }}>
                      <Image
                        src={imaLogo}
                        className="logoCrearCuenta"
                        centered
                      />
                      <Header as="h3">
                        {necesitas_ayuda_con_tu_contrasena}
                      </Header>
                      <Box
                        //component="form"
                        sx={{
                          "& > :not(style)": { m: 1, width: "25ch" },
                        }}
                        noValidate
                        autoComplete="off"
                      >
                        <label>
                          {
                            ingresa_el_codigo_de_recuperacion_que_recibiste_en_tu_casilla_de_correo
                          }
                        </label>
                        <br></br>
                        <br></br>
                        <br></br>

                        <TextField
                          id="codigorecuperacion"
                          label={codigo_de_recuperacion}
                          placeholder={codigo_de_recuperacion}
                          variant="standard"
                          name="codigorecuperacion"
                          type="text"
                          icon="key"
                          value={formik.values.codigorecuperacion}
                          onChange={formik.handleChange}
                          error={
                            formik.touched.codigorecuperacion &&
                            Boolean(formik.errors.codigorecuperacion)
                          }
                          helperText={
                            formik.touched.codigorecuperacion &&
                            formik.errors.codigorecuperacion
                          }
                        />
                      </Box>
                      {/* </form>*/}
                    </Grid.Column>
                  </div>
                </Grid.Row>
              </Grid>
            </Segment>
          </Container>
          <ScrollTop {...props}>
            <Fab size="small" aria-label="scroll back to top">
              <KeyboardArrowUpIcon />
            </Fab>
          </ScrollTop>
        </React.Fragment>
      </form>
    </div>
  );
}
